import { apiBaseUrl } from '../../environment/environment'
export default {
  login: apiBaseUrl + 'capricorn/auth/login',
  requestCredentials: apiBaseUrl + 'capricorn/auth/register',
  setPassword: apiBaseUrl + 'capricorn/auth/setPassword',
  logout: apiBaseUrl + 'capricorn/auth/logout',
  sendLink: apiBaseUrl + 'capricorn/auth/resetPassword'
}
